import { QueryKeys } from '../../../enums/queryKeys'
import { ContactsQueryProps } from '../hooks/useFetchContacts'

export const getContactsQueryKey = (queryProps: ContactsQueryProps): [QueryKeys, ContactsQueryProps] => [
  QueryKeys.ContactsAndContactPersons,
  queryProps,
]
